import { ActionTree, ActionContext } from "vuex"
import { RootState } from "@/store"
import { NotificationState } from "./state"
import { NotificationMutationTypes } from "./mutation-types"
import { NotificationActionTypes } from "./action-types"
import { getUnreadCount } from "@/apis/notification"
import { Client } from "@stomp/stompjs"
import SockJS from "sockjs-client"
import { ElMessage } from "element-plus"

let stompClient: Client | null = null

export type AugmentedActionContext = {
  commit<K extends keyof import("./mutations").Mutations>(
    key: K,
    payload: Parameters<import("./mutations").Mutations[K]>[1]
  ): ReturnType<import("./mutations").Mutations[K]>
} & Omit<ActionContext<NotificationState, RootState>, "commit">

export interface Actions {
  [NotificationActionTypes.ACTION_GET_UNREAD_COUNT](
    { commit }: AugmentedActionContext
  ): Promise<void>
  [NotificationActionTypes.ACTION_INIT_WEBSOCKET](
    { commit, rootState }: AugmentedActionContext
  ): void
  [NotificationActionTypes.ACTION_CLOSE_WEBSOCKET](
    { commit }: AugmentedActionContext
  ): void
}

export const actions: ActionTree<NotificationState, RootState> & Actions = {
  async [NotificationActionTypes.ACTION_GET_UNREAD_COUNT]({ commit }) {
    try {
      const data = await getUnreadCount()
      commit(NotificationMutationTypes.SET_UNREAD_COUNT, data)
    } catch (error) {
      console.error("Failed to get unread count:", error)
    }
  },

  [NotificationActionTypes.ACTION_INIT_WEBSOCKET]({ commit, rootState }) {
    if (stompClient) return

    const userId = rootState.user.userId
    if (!userId) return

    const token = rootState.user.token
    stompClient = new Client({
      webSocketFactory: () => new SockJS(window.location.origin + "/api/ws?token=" + encodeURIComponent(token)),
      debug: (str) => {
        // console.log(str)
      },
      reconnectDelay: 5000,
      heartbeatIncoming: 4000,
      heartbeatOutgoing: 4000,
    })

    stompClient.onConnect = (frame) => {
      // console.log("Connected: " + frame)
      stompClient?.subscribe(`/user/queue/notify`, (message) => {
        const notification = JSON.parse(message.body)
        ElMessage({
          message: notification.title || "您有一条新消息",
          type: "info",
          duration: 3000
        })
        commit(NotificationMutationTypes.INCREMENT_UNREAD_COUNT, undefined)
      })
    }

    stompClient.onStompError = (frame) => {
      console.error("STOMP error", frame)
    }

    stompClient.activate()
  },

  [NotificationActionTypes.ACTION_CLOSE_WEBSOCKET]() {
    if (stompClient) {
      stompClient.deactivate()
      stompClient = null
    }
  }
}